import Phaser from 'phaser-ce';
import GameObject from './GameObject';
import gameConsts from './gameConsts';

export default class RoadObject extends GameObject {
  constructor({ game, player, values, road, name }) {
    super({
      game,
      name,
      values,
    });
    this.item = this._game.add.sprite(0, -gameConsts.GAME_HEIGHT, 'nfs', `${this._name}.png`);
    this._player = player;
    this._road = road;
    this._deltaSpeed = 0;
    this.isActive = false;
  }
  get _bodyOffsetY() {
    return 2 * ((this._road.defaultSpeed - this._deltaSpeed) / this._scaleValue);
  }
  _move() {
    this.item.y += (this._road.speed - this._deltaSpeed);
  }
  _checkOutScreen() {
    // удаляем иконку за пределами границы экрана
    if (this.item.y >= gameConsts.GAME_HEIGHT) {
      this.isActive = false;
      this.tween = {};
    }
  }
  _activate(type) {
    if (Math.random() <= this._chance && !(this.isActive)) {
      this._setRandomX();
      this.item.y = -gameConsts.GAME_HEIGHT;
      this._setArea();
      if (type === 'bonus') {
        this.isActive = true;
      } else if (type === 'obstacle') {
        this._checkCollisionArea();
      }
    }
  }
  create() {
    this._game.physics.enable(this.item, Phaser.Physics.ARCADE);
    this.item.body.immovable = true;
  }
  restart() {
    // выбрасываем бонусы за экран
    this.item.y = -gameConsts.GAME_HEIGHT;
    this.isActive = false;
    this.tween = {};
  }
}



// WEBPACK FOOTER //
// ./src/js/RoadObject.js